import { ReactNode, useEffect, useRef } from 'react'
import Modal from '../common/Modal/Modal'
import { Card, CardTitle, Muted, PrimaryButton, Row, SecondaryButton } from '../affiliate/ui'

/**
 * Asks before something that writes to production. Cancel is the primary (and focused) button, so a quick
 * Enter or a stray click backs out rather than going ahead.
 */
const ConfirmDialog = ({
    open,
    title,
    children,
    continueLabel = 'Continue',
    onContinue,
    onCancel,
}: {
    open: boolean
    title: string
    children: ReactNode
    continueLabel?: string
    onContinue: () => void
    onCancel: () => void
}) => {
    const cancelRef = useRef<HTMLButtonElement>(null)

    useEffect(() => {
        if (!open) return
        cancelRef.current?.focus()
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onCancel()
        }
        window.addEventListener('keydown', onKey)
        return () => window.removeEventListener('keydown', onKey)
    }, [open, onCancel])

    return (
        <Modal showModal={open} toggleModal={onCancel}>
            <Card
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="droplist-confirm-title"
                style={{ width: '100%', background: '#1c1d2b', border: '1px solid rgba(255,255,255,0.1)' }}
            >
                <CardTitle id="droplist-confirm-title">{title}</CardTitle>
                <Muted as="div">{children}</Muted>
                <Row style={{ justifyContent: 'flex-end' }}>
                    <SecondaryButton type="button" onClick={onContinue}>
                        {continueLabel}
                    </SecondaryButton>
                    <PrimaryButton type="button" ref={cancelRef} onClick={onCancel}>
                        Cancel
                    </PrimaryButton>
                </Row>
            </Card>
        </Modal>
    )
}

export default ConfirmDialog
